/** 当前站点所属培训平台 ID（对应后端 trainClass.trainProject.subSystem.id） */
export const PLATFORM_ID = '1'

/** 后端已支持 platformId 条件查询的接口 */
const PLATFORM_API_URLS = [
  '/user/toMyClass.do',
  '/user/toMyClassById.do',
  '/user/toMyClassPage.do',
  '/user/toMyClassCourse.do',
  '/order/toOrderList.do',
  '/order/toShoppingCart.do',
  '/order/toOrderPageList.do'
]

export function isPlatformApi(url = '') {
  return PLATFORM_API_URLS.some((path) => url.indexOf(path) !== -1)
}

/** 为请求参数合并 platformId，调用方传入的值优先 */
export function withPlatformParams(data = {}) {
  return {
    ...data,
    platformId: data.platformId != null && data.platformId !== '' ? data.platformId : PLATFORM_ID
  }
}
